import {PublishedJson} from '@nirby/models/pop';
import {Migrator} from '@nirby/store/migrator';
import {z} from 'zod';

export const PUBLISHED_MIGRATOR = new Migrator<PublishedJson>(z.any(), () => ({
    json: 'null',
}));
